import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import OnlineApp from './OnlineApp';

import './index.scss';

let root: any = null;
// @ts-ignore
window.renderTMCommunication = (containerId) => {
    root = ReactDOM.createRoot(
        document.getElementById(containerId) as HTMLElement
    );
    root.render(<App />);
};
// @ts-ignore
window.unmountTMCommunication = containerId => {
    if (root) {
        root.unmount();
    }
};
let onlineRoot: any = null;
// @ts-ignore
window.renderTMCommunicationOnline = (containerId) => {
    onlineRoot = ReactDOM.createRoot(
        document.getElementById(containerId) as HTMLElement
    );
    onlineRoot.render(<OnlineApp />);
};
// @ts-ignore
window.unmountTMCommunicationOnline = containerId => {
    if (onlineRoot) {
        onlineRoot.unmount();
    }
};
if ((!document.getElementById('TMCommunication-container') || 
    !document.getElementById('TMCommunicationOnline-container')) && document.getElementById('communicationRoot')) {
    root = ReactDOM.createRoot(
        document.getElementById('communicationRoot') as HTMLElement
    );
    root.render(<App/>);
}
